+(function ($) {
	var photoUploader = function(form, options) {
		var self = this;
		var $form = $(form);
		var settings = $.extend({
			uploadUrl: '',
			itemClass: '.upload-item',
            imagePreview: {}
		}, options);

		this.completed = 0;
		this.total = $(settings.itemClass).length;

		$form.find('.cancel-upload').on('click', function(e) {
		    e.stopPropagation();
		    e.preventDefault();

		    $(this).hide();
		    self.completed = self.total;
		    // self.checkSubmitDelayed();
		    $form.off('submit').trigger('submit');
        });

		this.init = function() {
			$form.on('submit', function(e) {
				var uploaded = false;

				e.preventDefault();

				$(settings.itemClass).each(function() {
					if (self.uploadPhoto($(this))) {
					    uploaded = true;
                    }
				});

				if (!uploaded) {
					$form.off('submit');

					if (typeof settings.onCompleted == 'function') {
						settings.onCompleted();
					} else {
						$form.trigger('submit');
					}
				}
			});

			$(settings.itemClass).each(function() {
				$(this).data('uploadImage', new imagePreview($(this), settings.imagePreview));
			});
		};

		this.uploadPhoto = function($item) {
			var fd        = new FormData($form[0]);
			var blob      = $item.data('uploadImage').getBlob();

			if (blob == '' || !$item.is(':visible')) {
				// this.completed++;
				// this.checkSubmit();
				return false;
			}

			if ($item.attr('data-answer_id') !== undefined) {
				fd.append('answer_id', $item.attr('data-answer_id'));
			}

			fd.append('counter', $item.attr('data-counter'));
			fd.append('photo', blob);

			var xhr = new XMLHttpRequest();
			xhr.upload.addEventListener("progress", this.uploadProgress, false);
			xhr.addEventListener("load", this.uploadComplete, false);
			xhr.addEventListener("error", this.uploadFailed, false);
			xhr.addEventListener("abort", this.uploadCancelled, false);
			xhr.open("POST", settings.uploadUrl);
			xhr.send(fd);

			$form.find('.cancel-upload').css('display', 'inline-block');
			return true;
		};

		this.uploadProgress = function(evt) {
			if (evt.lengthComputable) {
				var percentComplete = Math.round(evt.loaded * 100 / evt.total);
				$form.find('.upload-progress').addClass('active');
				$form.find('.upload-progress span').css('width', percentComplete + '%');

			} else {
				$form.find('.upload-progress').removeClass('active');
			}
		};

		this.uploadComplete = function(evt) {
			self.completed++;
			self.checkSubmitDelayed();
		};

		this.uploadFailed = function(evt) {
			self.completed++;
			self.checkSubmitDelayed();
		};

		this.uploadCancelled = function(evt) {
			self.completed++;
			self.checkSubmitDelayed();
		};

		this.checkSubmitDelayed = function() {
			if (this.completed > 0 && this.completed == this.total) {
				setTimeout(function() {
			        $form.find('.cancel-upload').hide();
                    $form.off('submit');

				    if (typeof settings.onCompleted == 'function') {
                        settings.onCompleted();

                    } else {
					    $form.trigger('submit');
                    }
				}, 10);
			}
		};

		this.checkSubmit = function() {
			if (this.completed > 0 && this.completed == this.total) {
				$form.off('submit');

				if (typeof settings.onCompleted == 'function') {
					settings.onCompleted();

				} else {
					$form.trigger('submit');
				}
			}
		};
	};

	$.fn.photoUploader = function(options) {
		return this.each(function () {
			var uploader = new photoUploader(this, options);
			uploader.init();
		});
	};
})(jQuery);

var imagePreview = function($wrapper, settings) {
	var self = this;

	this.settings = $.extend({
	    onLoad: false
    }, settings);

	this.img = new Image();
	this.maxWidth = 1000;
	this.unsharpAmount = 80; //50, // 0..100
	this.unsharpRadius = 0.6; //0.6, // 0.5..2.0
	this.unsharpThreshold = 2; //2; // 0..255
	this.previewed = false;

	this.$wrapper = $wrapper;
	this.$fileInput = $wrapper.find('input[type=file]');
	this.canvas = $wrapper.find('canvas').get(0);

	this.img.onload = function() {
		self.resize();
	};

	$wrapper.find('.file-block').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		self.$fileInput.trigger('click');
	});

	self.$fileInput.on('change', function() {
		var files = $(this).get(0).files;
		if (files.length === 0) return;
		var imgSrc = window.URL.createObjectURL(files[0]);

		$wrapper.find('.select-file-loader').removeClass('d-none');
		$wrapper.find('.select-file, .current').addClass('d-none');
		$wrapper.find('.canvas-wrapper').removeClass('d-none');

		EXIF.getData(files[0], function() {
			var orientation = EXIF.getTag(this, 'Orientation');

			var rotator = new imageRotator(imgSrc, function() {
				rotator.rotateByOrientation(orientation, function(src) {
				    self.img.src = src;
                });
			});
		});

		$(this).val('');
	});
};

imagePreview.prototype.resize = function() {
	var self = this;
	var canvasWidth = self.img.width > self.maxWidth ? self.maxWidth : self.img.width;

	//self.rotate(orientation);
	self.canvas.width = canvasWidth;
	self.canvas.height = self.img.height * canvasWidth / self.img.width;

	window.pica().resize(self.img, self.canvas, {
		alpha: false,
		unsharpAmount: self.unsharpAmount,
		unsharpRadius: self.unsharpRadius,
		unsharpThreshold: self.unsharpThreshold,
		transferable: true
	}).then(function() {
		if (typeof self.settings.onLoad == 'function') {
            self.settings.onLoad(self);
        }

		self.previewed = true;
		self.$wrapper.find('.select-file-loader').addClass('d-none');
	}).catch(function(err) {

	});
};

imagePreview.prototype.getBlob = function() {
	if (!this.previewed) {
		return '';
	}

	var imgData = this.canvas.toDataURL("image/jpeg", 1);
	return this.dataURItoBlob(imgData);
};

imagePreview.prototype.getBlobSize = function() {
	var that = this;
	var imgData = that.canvas.toDataURL("image/jpeg", 1);
	var blob    = that.dataURItoBlob(imgData);
	// test image: 140.17 KB (143,529 bytes)
    
    return blob.size;
};

imagePreview.prototype.dataURItoBlob = function(dataURI) {
	'use strict'
	var byteString, mimestring;

	if (dataURI.split(',')[0].indexOf('base64') !== -1 ) {
		byteString = atob(dataURI.split(',')[1]);
	} else {
		byteString = decodeURI(dataURI.split(',')[1]);
	}

	mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0];
	var content = new Array();

	for (var i = 0; i < byteString.length; i++) {
		content[i] = byteString.charCodeAt(i);
	}
	return new Blob([new Uint8Array(content)], {type: mimestring});
};




var imageRotator = function(imageSrc, callback) {
	var self = this;

	this.canvas = document.createElement('canvas');
	this.ctx    = this.canvas.getContext('2d');
	this.image  = new Image();

	this.image.onload = function() {
		callback(self);
	}

	this.image.src = imageSrc;
};

imageRotator.prototype.checkAutoOrientation = function(callback) {
    // var support = getComputedStyle(document.body)['imageOrientation'] == 'from-image';
    // alert("autorotate support: " + (support ? "true" : "false"));
    // return support;

    // Check if the browser supports automatic image orientation. This will check with an 2x1 image with exif
    // rotation 6.
    var testImageURL =
        'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
        'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
        'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
        'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/x' +
        'ABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAA' +
        'AAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q=='
    var img = document.createElement('img');

    img.onload = function() {
        // console.log("if autorotate, this should be 1 x 2:", img.width, 'x', img.height, img.width === 1 && img.height === 2);
        // alert("autorotate support: " + (img.width === 1 && img.height === 2 ? 'true' : 'false'));
        callback(img.width === 1 && img.height === 2);
    }

    img.src = testImageURL;
};

imageRotator.prototype.rotateByOrientation = function(orientation, callback) {
	// 1 = normaal
	// 2 = gespiegeld
	// 3 = op de kop
	// 4 = gespiegeld op de kop
	// 5 = gespiegeld links geroteerd
	// 6 = links geroteerd
	// 7 = gespiegeld rechts geroteerd
	// 8 = rechts geroteerd

	//if (orientation == 1) return;
    var self   = this;
	var width  = this.image.width;
	var height = this.image.height;
	var x = 0, y = 0, deg = 0;

	this.canvas.width = width;
	this.canvas.height = height;
	this.ctx.scale(1, 1);

    this.checkAutoOrientation(function(hasAutoRotation) {
        if (!hasAutoRotation) {
            if (orientation >= 5) {
                self.canvas.width  = height;
                self.canvas.height = width;
            }

            if (orientation == 2) { self.ctx.scale(-1, 1); x = width * -1; }
            if (orientation == 3) { deg = 180; x = width * -1; y = height * -1; }
            if (orientation == 4) { self.ctx.scale(-1, 1); deg = 180; y = height * -1; }
            if (orientation == 5) { self.ctx.scale(-1, 1); deg = 90; }
            if (orientation == 6) { deg = 90; y = height * -1; }
            if (orientation == 7) { self.ctx.scale(-1, 1); deg = 270; x = width * -1; y = height * -1; }
            if (orientation == 8) { deg = 270; x = width * -1; }

            self.ctx.rotate(deg * Math.PI / 180);
        }

        self.ctx.drawImage(self.image, x, y);
        var src = self.canvas.toDataURL();

        callback(src);
    });
};

